import { Button, Col, Divider, Modal, Row } from 'antd';
import React, { ReactElement, useContext, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter, useHistory } from 'react-router-dom';
import * as moment from 'moment';
import Panel from '../../../../../../../shared/components/card/Panel';
import { FormCheckBox, FormInputDate, FormInputMobile, FormSelect, FormTextInput } from '../../../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE } from '../../../../../../../shared/constants/commonConstants';
import { RootState } from '../../../../../../../store';
import {
  checkIfDelayedAdmsission,
  disabledDateOfDOA, doaDodValidation, getDefaultDiagnosis, getIsPageNameEdit, getIsPageNameEditDischarge, getIsPageNameNewAdmission,
  getIsPageNameReconsider,
  getNoOfDays, getSelectedDiagnosisIds, isToday,
} from '../../../../service/crmUtils';
import ClaimDetailHeader from '../ClaimDetailHeader/ClaimDetailHeader';
import FormAutoComplete from '../../../../../../../shared/components/crmFormElement/FormAutoComplete/FormAutoComplete';
import { checkDuplicateClaim, setDelayedAdmission, setExistingClaimError, setExtraFormValues, setIsCovidCase, setIsDischargeCase,
   updateDefaultTimeline } from '../../../../../../../store/actions/newAdmissionAction';
import { intersection, isEmpty, isEqual, noop } from 'lodash';
import { CATARACT_DIAGNOSIS_TYPE, DIALYSIS_DIAGNOSIS_TYPE, MATERNITY_DIAGNOSIS_TYPE, MAX_LOS_ALLOWED_WITHOUT_WARNING } from '../../../../../../../shared/constants/crmConstants';
import { setCardCollapse } from '../../../../../../../store/actions/newAdmissionAction';
import { useSmoothScroll } from '../../../../../../../shared/hooks/useSmoothScroll';
import { AdmissionContext } from '../../../AdmissionContext';
import { usePrevious } from '../../../../../../../shared/hooks/usePrevious';
import { getDateWithTextMonth } from '../../../../../../../utils/dateTimeUtils';
import Text from 'antd/lib/typography/Text';
import { InfoCircleTwoTone } from '@ant-design/icons';
import { updateSelectedDetail } from '../../../../../../../store/actions/inPatientAction';
import { base64UrlEncode } from '../../../../../../../utils/utility';
import { PayerInitialState } from '../../../../../../../store/models/payerListModel';
import DelayedIntimationPopUP from '../../../../../../../shared/components/DelayedIntimationPopup/DelayedIntimationPopUP';
import CONTROL_CONFIG_BASED_ON_PAYER from '../../../../../../../config/formControlConfig';
import PopuponLateDod from '../../../../../../../shared/components/PopuponLateDOD/PopuponLateDod';
import FormSwitch from '../../../../../../../shared/components/crmFormElement/FormSwitch/FormSwitch';

const TreatmentDetailCard = ({ isLoading, form, location: { pathname }, buddhimedForm }: any): ReactElement => {
  const dispatch = useDispatch();
  const [showDiagnosisMasterList, setShowDiagnosisMasterList] = useState(false);
  const history = useHistory();
  const [isLOSgtWarning, setIsLOSgtWarning] = useState(false);
  const [lengthOfStay, setLengthOfStay] = useState(0);
  const [isDeathCaseDisabled, setIsDeathCasedDisabled] = useState(true);
  const [isDelayModalVisible, setIsDelayModalVisible] = useState(false);
  const {
    payerLookUp = {}, lookUp, payerList: { payer: { uniqueIdentifier, isOnMailPayer, name } },
    newAdmission: { selectedBeneficiaryDetail = {}, extraFormValues = {}, cardCollapse,
      admissionFormVal, admissionFormVal: { treatmentDetail }, existingClaimError, defaultTimeline,
      disableRoomType, isDraftSelected,
    },
    admissionDetails: { claimDetails: claimDetail = {} },
  } = useSelector((state: RootState): RootState => state);
  const { payer } = useSelector((state: RootState): PayerInitialState => state.payerList);
  const isDelayedAdmission = useSelector((state: RootState): boolean => state.newAdmission.isDelayedAdmission || false);
  const { doctorList = [] } = payerLookUp[uniqueIdentifier] || {};

  const [disableDocRegNo, setDisableDocRegNo] = useState(false);
  const admissionContext = useContext(AdmissionContext);
  const { claimDetailBackup } = admissionContext;

  const isNewAdmissionPage = getIsPageNameNewAdmission(pathname);
  const { policyStartDate, policyEndDate }: any = selectedBeneficiaryDetail || {};

  const { roomType: rType = '' } = form.getFieldsValue(['roomType']) || {};
  claimDetailBackup.roomType = rType;

  useSmoothScroll('treatment-scroll');
  const prevTreatmentDetail = usePrevious(treatmentDetail);
  const payerConfig = CONTROL_CONFIG_BASED_ON_PAYER[name];

  let formElementCount: any[] = [];
  let doaDifferenceLimit: number;
  if (payerConfig) {
    const payerConfigValues = Object.values(payerConfig || '');
    formElementCount = payerConfigValues?.filter(({ type, hidden }: any): boolean => type === 'DELAY_ADMISSION_REMARK' && !hidden);
    const delayAdmissionObject = formElementCount[0];
    doaDifferenceLimit = delayAdmissionObject?.['doaLimit'] ? delayAdmissionObject['doaLimit'] : 3;
  }
  useEffect((): any => {
    checkIfDeathFlagDisabled();
    if (claimDetail && Object.keys(claimDetail).length) {
      const { diagnosis, diagnosisMandatory } = claimDetail;
      if (diagnosis || diagnosisMandatory === 'Other') {
        form.setFieldsValue({ diagnosisMandatory: 'Other' });
        onChangeMandatoryDiagnosis('Other');
      }
      const { originalDiagnosis = [] } = claimDetail;
      const diagnosisIds = originalDiagnosis.map(({ payerMasterId }: any): string => (payerMasterId || '').toString());
      setBooleanInCard(diagnosisIds);
      const { doctorRegNo } = form.getFieldsValue(['doctorRegNo']);
      if (doctorRegNo && !isDraftSelected && !isNewAdmissionPage) {
        setDisableDocRegNo(true);
      }
    }
  }, []);

  const onSearchDoctor = (): void => {
    const { doctor } = extraFormValues;
    form.setFieldsValue({ doctorRegNo: '' });
    setDisableDocRegNo(false);
    if (doctor) {
      dispatch(setExtraFormValues({ ...extraFormValues, doctor: undefined }));
    }
  };

  useEffect((): void => {
    if (!isEqual(treatmentDetail, prevTreatmentDetail) && !isEmpty(treatmentDetail) && isEmpty(claimDetail)) {
      const { treatmentDetail: { diagnosis: diagnosisVal, diagnosisMandatory } } = admissionFormVal;
      diagnosisMandatory ? onChangeMandatoryDiagnosis(diagnosisMandatory) : noop();
      if (diagnosisVal) {
        onChangeDiagnosis(diagnosisVal);
      }
    }
  }, [admissionFormVal]);

  const onSelectDoctor = (...option: any[]): void => {
    const { key } = option[1];
    if (key) {
      const { registrationNo } = doctorList.find(({ value }: any): boolean => value === parseInt(key, 10));
      if (registrationNo) {
        form.setFieldsValue({ doctorRegNo: registrationNo });
        setDisableDocRegNo(true);
      }
    }
    dispatch(setExtraFormValues({ ...extraFormValues, doctor: option[1] }));
  };

  const commonDetail = { isLoading, form, claimDetailBackup };

  const onChangeMandatoryDiagnosis = (event: any): void => {
    if (event !== 'Other') {
      setShowDiagnosisMasterList(false);
      const selectedDiagnosisIds = getSelectedDiagnosisIds([event],
        payerLookUp[uniqueIdentifier]?.diagnosis)
        .filter((val: string): boolean => !!val);
      form.setFieldsValue({
        icd10: selectedDiagnosisIds.join(', '),
      });
      setBooleanInCard(selectedDiagnosisIds);
    } else {
      setBooleanInCard([]);
      setShowDiagnosisMasterList(true);
    }
  };

  const onChangeDiagnosis = (event: any = []): void => {
    const selectedDiagnosisIds = getSelectedDiagnosisIds(event, payerLookUp[uniqueIdentifier]?.diagnosis)
      .filter((val: string): boolean => !!val);
    form.setFieldsValue({
      icd10: selectedDiagnosisIds.join(', '),
    });
    setBooleanInCard(selectedDiagnosisIds);
  };

  const setBooleanInCard = (selectedDiagnosisIds: string[]): void => {
    const isMaternityOpen = !!intersection(selectedDiagnosisIds, MATERNITY_DIAGNOSIS_TYPE).length;
    if (!isMaternityOpen) {
      form.validateFields(['obstetricHistoryG', 'obstetricHistoryP', 'obstetricHistoryL', 'obstetricHistoryA', 'deliveryDate', 'maternityType']);
    }
    const isOtherTreatmentDetailOpen = !!intersection(selectedDiagnosisIds, CATARACT_DIAGNOSIS_TYPE.concat(DIALYSIS_DIAGNOSIS_TYPE)).length;

    dispatch(setCardCollapse({ ...cardCollapse, isMaternityOpen, isOtherTreatmentDetailOpen, selectedDiagnosisIds }));
    if (!isOtherTreatmentDetailOpen) {
      form.validateFields(['contactLensType', 'cataractType']);
    }
  };

  const validateDate = (...props: any): any => {
    const { dateOfAdmission, dateOfDischarge, fullName } = form.getFieldsValue(['dateOfAdmission', 'dateOfDischarge', 'fullName']);
    checkIfDeathFlagDisabled();
    if (dateOfAdmission && dateOfDischarge) {
      form.validateFields(['dateOfAdmission', 'dateOfDischarge']);
      const los = getNoOfDays(dateOfAdmission, dateOfDischarge);
      setLengthOfStay(los);
      if (los > MAX_LOS_ALLOWED_WITHOUT_WARNING) {
        setIsLOSgtWarning(true);
      } else {
        if (!isOnMailPayer) {
          const payload = {
            patientName: selectedBeneficiaryDetail?.memberName || fullName,
            doa: dateOfAdmission,
            dod: dateOfDischarge,
            memberId: selectedBeneficiaryDetail?.memberId,
            payerId: selectedBeneficiaryDetail?.payerId || payer?.id,
            schemeType: selectedBeneficiaryDetail?.productCode,
            action: 'NEWADMISSION',
          };
          dispatch(checkDuplicateClaim(payload));
        }
        setIsLOSgtWarning(false);
        defaultTimeline['remarks']['Remarks for LOS >90 days'] = undefined;
        form.resetFields(['LOSgt90']);
        dispatch(updateDefaultTimeline(defaultTimeline));
      }
    }
  };

  const onDOAChange = (...props: any): any => {
    validateDate(props);
    if (checkIfDelayedAdmsission(form, pathname, formElementCount.length > 0, doaDifferenceLimit)) {
      dispatch(setDelayedAdmission(true));
      setIsDelayModalVisible(true);
    } else {
      dispatch(setDelayedAdmission(false));
      defaultTimeline['remarks']['Remarks for delayed intimation'] = undefined;
      form.resetFields(['delayedAdmissionRemark']);
      dispatch(updateDefaultTimeline(defaultTimeline));
    }
  };

  const onCancelPopConfirm = (): any => {
    form.setFieldsValue({ dateOfDischarge: '' });
    setIsLOSgtWarning(false);
  };

  const handleExsitingClaim = (event: any): any => {
    const { duplicateClaimDetails } = existingClaimError;
    const payload = event.currentTarget.value ? event.currentTarget.value : event.currentTarget.getAttribute('aria-label');
    if (payload === 'yes' && !isEmpty(duplicateClaimDetails)) {
      dispatch(updateSelectedDetail(duplicateClaimDetails));
      const { payerClaimNo: claimNo, hospActionId, payerId, productCode } = duplicateClaimDetails;
      const payerClaimNo = base64UrlEncode(claimNo);
      const isCancel = false;
      const uniquePayerId = `${payerId}${productCode || ''}`;
      history.push(`/claims/in-patient/detail/${base64UrlEncode(`${payerClaimNo}/${hospActionId}/${payerId}
      /${uniquePayerId}/${productCode}/${isCancel}`)}`);
      dispatch(setExistingClaimError({}));
    } else if (payload === 'no') {
      history.push(`/claims/in-patient`);
      dispatch(setExistingClaimError({}));
    } else {
      dispatch(setExistingClaimError({ isError: true }));
    }
  };

  const checkIfDeathFlagDisabled = (): any => {
    const { nextAllowStatus = [], isDeathCase } = claimDetail;
    if (getIsPageNameEdit(pathname) || getIsPageNameEditDischarge(pathname) ||
      getIsPageNameReconsider(pathname) || getIsPageNameNewAdmission(pathname)) {
      if (nextAllowStatus.includes('DISCHARGE') || isToday(form.getFieldsValue()?.dateOfDischarge)) {
        setIsDeathCasedDisabled(false);
      } else {
        setIsDeathCasedDisabled(true);
        form.setFieldsValue({ isDeathCase: [isDeathCase ? isDeathCase : null] });
      }
    }
  };

  const dischargeSwitchHandler = (ev: any): any => {
    dispatch(setIsDischargeCase(ev.target.checked));
  };
  const onChangeCovid = (ev: any): any => {
    dispatch(setIsCovidCase(ev.target.checked));
  };

  return <Panel className="treatment-scroll" data-testid="treatment-detail">
    {
      !isNewAdmissionPage ? <ClaimDetailHeader /> : null
    }
    <Row gutter={GUTTOR_SPACE}>
      <FormInputDate detail={{
        ...commonDetail,
        key: 'dateOfAdmission',
        size: 12,
        showTime: true,
        allowClear: false,
        onChange: onDOAChange,
        extraFooter: (): any => (
          policyEndDate && <Text type="secondary">
            <InfoCircleTwoTone className="mr-5" />
            Policy expiry date is <strong>{getDateWithTextMonth(policyEndDate)}</strong>.
          </Text>
        ),
        disabledDate: (current: any): boolean => disabledDateOfDOA(current, policyStartDate, policyEndDate),
      }} />
      <FormInputDate detail={{
        ...commonDetail,
        key: 'dateOfDischarge',
        size: 12,
        showTime: true,
        allowClear: false,
        onChange: validateDate,
        disabledDate: (current: any): boolean => (form.getFieldsValue(['dateOfAdmission'])?.dateOfAdmission
          && current < moment.default(form.getFieldsValue(['dateOfAdmission']).dateOfAdmission)),
        rules: [doaDodValidation],
      }} />
      <FormAutoComplete detail={{
        ...commonDetail,
        key: 'doctorName',
        size: 12,
        onSearch: onSearchDoctor,
        onSelect: onSelectDoctor,
        options: doctorList,
        isName: true,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'doctorRegNo',
        size: 12,
        disabled: disableDocRegNo,
        regex: /[^a-zA-Z\d\-]*/gm,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'doctorQualification',
        size: 16,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'presentComplaints',
        size: 16,
      }} />
      <FormInputMobile detail={{
        ...commonDetail,
        key: 'doctorMobileNo',
        size: 14,
      }} />
      <FormSelect detail={{
        ...commonDetail,
        key: 'payerRoomType',
        size: 12,
        options: (payerLookUp[uniqueIdentifier]?.roomType || []),
        showSearch: true,
        disabled: disableRoomType,
      }} />
      <FormTextInput detail={{
        ...commonDetail,
        key: 'roomTypeText',
        size: 12,
        disabled: disableRoomType,
      }}
      />
    </Row>
    <Divider />
    <Row gutter={GUTTOR_SPACE}>
      <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormCheckBox detail={{
            ...commonDetail,
            key: 'proposedLineOfTreatment',
            size: 24,
            checkBoxColSize: 24,
            options: [...lookUp.proposedLineOfTreatment],
            showSearch: true,
          }} />
        </Row>
        <Row gutter={GUTTOR_SPACE}>
          <FormCheckBox
            detail={{
              ...commonDetail,
              key: 'isDischargeCase',
              options: [{ value: 'Yes', name: 'Yes', onChange: dischargeSwitchHandler }],
              size: 24,
            }}
          />
        </Row>
      </Col>
      <Col md={12}>
        <Row gutter={GUTTOR_SPACE}>
          <FormSelect detail={{
            ...commonDetail,
            key: 'diagnosisMandatory',
            size: 24,
            options: getDefaultDiagnosis(payerLookUp[uniqueIdentifier]?.diagnosis || []) || [],
            showSearch: true,
            onChange: onChangeMandatoryDiagnosis,
            onlyAlphaNumeric: true,
          }} />
          {showDiagnosisMasterList ? <FormSelect detail={{
            ...commonDetail,
            key: 'diagnosis',
            size: 24,
            options: payerLookUp[uniqueIdentifier]?.diagnosis || [],
            showSearch: true,
            mode: 'tags',
            onChange: onChangeDiagnosis,
            isBadValueCheck: true,
            badValues: lookUp.badDiagnosis || [],
            onlyAlphaNumeric: true,
          }} /> : null}
          <FormTextInput detail={{
            ...commonDetail,
            key: 'icd10',
            size: 12,
            disabled: true,
          }} />
          <FormTextInput detail={{
            ...commonDetail,
            key: 'icd10pcs',
            size: 12,
            disabled: true,
          }} />
          <FormSelect detail={{
            ...commonDetail,
            key: 'procedure',
            size: 24,
            options: payerLookUp[uniqueIdentifier]?.procedure || [],
            showSearch: true,
            mode: 'tags',
            labelClass: 'mb-0',
            isBadValueCheck: true,
            badValues: lookUp.badTreatment || [],
            onlyAlphaNumeric: true,
          }} />
        </Row>
      </Col>
    </Row>
    <Row gutter={GUTTOR_SPACE}>
      <FormCheckBox detail={{
        ...commonDetail,
        key: 'isDeathCase',
        options: ['Yes'],
        size: 12,
        showSearch: true,
        disabled: isDeathCaseDisabled,
      }} />
    </Row>
      <Row gutter={GUTTOR_SPACE}>
      <FormCheckBox
        detail={{
          ...commonDetail,
          key: 'isCovidCase',
          options: [{ value: 'Yes', name: 'Yes', onChange: onChangeCovid }],
          size: 24,
        }}
      />
      </Row>
      <Row gutter={GUTTOR_SPACE}>
        <FormSwitch detail={{
          ...commonDetail,
          key: 'isMultipleSurgeries',
          size: 12,
        }} />
      </Row>
    <Modal
      visible={existingClaimError?.errorMessage}
      onCancel={handleExsitingClaim}
      footer={
        <Row>
          <Col span={2} offset={16}>
            <Button key="draft" data-testid="save-draft-modal" value="yes" onClick={handleExsitingClaim} type="primary">
              Yes
            </Button>
          </Col>
          <Col span={2} offset={2}>
            <Button key="cancel" data-testid="click-on-cancel" value="no" onClick={handleExsitingClaim}>No</Button>
          </Col>
        </Row>
      }
    >
      <InfoCircleTwoTone className="fsize_lg" />&nbsp;
      {existingClaimError?.errorMessage}
    </Modal>
    {
      isDelayedAdmission && <DelayedIntimationPopUP
        visible={isDelayModalVisible}
        setVisible={setIsDelayModalVisible}
        isLoading={isLoading}
        form={form}
        claimDetailBackup={claimDetailBackup}
      />
    }
    {
      isLOSgtWarning &&
      <PopuponLateDod
        visible={isLOSgtWarning}
        setVisible={setIsLOSgtWarning}
        lengthOfStay={lengthOfStay}
        form={form}
        onCancelPopConfirm={onCancelPopConfirm}
      />
    }
  </Panel>;
};

export default withRouter(TreatmentDetailCard);
